export const SET_PAYMENTS = 'SET_PAYMENTS';
export const SET_PAYMENTS_PAGINATION = 'SET_PAYMENTS_PAGINATION';
